import { Component } from '@theme/component';

class EchtPBVideoHero extends Component {
  #cleanup;

  connectedCallback() {
    super.connectedCallback();
    const video = this.querySelector('video');
    if (!video) return;
    const viewport = matchMedia('(min-width: 750px)');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const sources = [...video.querySelectorAll('source')];
    const updatePlayback = () => {
      video.pause();
      video.poster = viewport.matches ? this.dataset.desktopPoster : this.dataset.mobilePoster;
      if (reducedMotion.matches) {
        delete this.dataset.enhanced;
        if (video.hasAttribute('src')) {
          video.removeAttribute('src');
          video.load();
        }
        return;
      }
      video.src = sources[viewport.matches ? 1 : 0].dataset.src;
      video.load();
      this.dataset.enhanced = '';
      video.play().catch(() => { /* Autoplay restrictions leave the poster visible. */ });
    };
    video.muted = true;
    viewport.addEventListener('change', updatePlayback);
    reducedMotion.addEventListener('change', updatePlayback);
    updatePlayback();
    this.#cleanup = () => {
      video.pause();
      viewport.removeEventListener('change', updatePlayback);
      reducedMotion.removeEventListener('change', updatePlayback);
    };
  }

  disconnectedCallback() {
    this.#cleanup?.();
    super.disconnectedCallback();
  }
}

if (!customElements.get('echt-pb-video-hero')) {
  customElements.define('echt-pb-video-hero', EchtPBVideoHero);
}
